interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, description, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-2xl ${isCenter ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
          <span className="flex h-3 w-3 items-center justify-center">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
          </span>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-4 font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {description && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>}
    </div>
  );
}